import React, { PureComponent } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import { isNil, isEmpty } from "ramda"
import { Steps } from "antd"
import { Link } from "react-router-dom"
import { compose } from "recompose"
import { injectIntl, FormattedMessage } from "react-intl"
import Wizard from "../../components/new-mortgage-wizard"
import Text from "../../components/text"
import Box from "../../lib/ui/ui-box"
import WithSizes from "../../hocs/with-sizes.hoc"
import Logo from "../../components/logo"
import Footer from "../../components/footer"
import axios from "axios"

import { getUserLanguage } from "../../utils/analytics"

const Step = Steps.Step

const FAQLink = styled.a`
  align-self: flex-end;
  margin-left: auto;
`

const MAP_QUESTIONS_TO_PAGE = {
  1: "Estimating how much cash you can get.",
  2: "End"
}

class Container extends PureComponent {
  state = {
    loanMaxAmount: ""
  }
  static propTypes = {
    isDesktopAndGreater: PropTypes.bool
  }

  sendValues = async () => {
    const {
      calculatorAgeOfYoungestHomeOwner,
      calculatorEstimatedHomeValue,
      calculatorProvince,
      calculatorTown
    } = this.props
    try {
      const response = await axios.post(
        "https://api.canadalistings.net/eq.php?calculator=1",
        {
          Age: calculatorAgeOfYoungestHomeOwner,
          HomeCurrentValue: calculatorEstimatedHomeValue,
          InitialAdvance: 45000,
          InitialAdvanceDateUTC: "2018-09-28T04:00:00.000Z",
          RecurringAdvanceId: 1,
          RecurringAdvanceDateUTC: "2018-09-28T04:00:00.000Z",
          LumpSumAdvances: [],
          HomeLocation: calculatorProvince,
          HomeCity: calculatorTown,
          Name: "rty",
          InterestRate: 0.0674,
          RecurringAdvanceAmount: 0,
          RecurringAdvanceNumber: 0,
          HomeRateModifier: 0.03,
          InterestRateModifier: 0.0025,
          InterestRateCompound: 2,
          InitialAdvanceAbsoluteMax: 800000
        }
      )
      await axios.post(
        "https://api.canadalistings.net/eq.php?calculator=1",
        response
      )
      console.log("Successful post request:", response.data.Data.LoanMaxAmount)
      this.setState({ loanMaxAmount: response.data.Data.LoanMaxAmount })
    } catch (err) {
      console.log(err)
    }
  }
  goTo = page => {
    const { history, intl } = this.props
    if (page === 2) {
      history.push(`${intl.formatMessage({ id: "routes.calculator" })}/${2}`)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { match: { params } } = this.props
    if (params.page === "2" && prevProps.match.params.page !== params.page) {
      this.sendValues()
    }
  }

  validateStep = (step, currentStep, stepName) => {
    const { stepValidationMap } = this.props
    if (currentStep === step) {
      // return "In Progress"
      return <div>&nbsp;</div>
    } else if (stepValidationMap[stepName] === true) {
      // return "Completed"
      return <div>&nbsp;</div>
    } else {
      // return "Waiting"
      return <div>&nbsp;</div>
    }
  }

  render() {
    const { match, isDesktopAndGreater, intl } = this.props
    const currentStep = match.params.page && Number(match.params.page) - 1
    const page = Number(match.params.page)

    return (
      <Box flexDirection="column" bg="white" align="center" mx="auto">
        <Box
          flexDirection="column"
          mt={[5]}
          w={["95%", "90%", "80%", "1200px"]}
        >
          <Box align="center" flexDirection="row">
            <Link to="/">
              <Logo src="/logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
            </Link>
            <Box
              align="center"
              mt={[3]}
              ml={[4]}
              onClick={() =>
                window.analytics.track("click to call", {
                  category: "contact",
                  location: `${MAP_QUESTIONS_TO_PAGE[page]}`,
                  label: `${MAP_QUESTIONS_TO_PAGE[page]}`,
                  language: getUserLanguage()
                })
              }
            >
              <a
                href={`tel:${intl.formatMessage({
                  id: "nav.numberFormatted"
                })}`}
              >
                <Text
                  fontFamily="Libre Baskerville"
                  fontWeight="700"
                  fontSize={[1]}
                  color="actionPrimary"
                  align="center"
                >
                  <FormattedMessage id="nav.number" defaults="613-769-9213" />
                </Text>
              </a>
            </Box>
            {/* Link To FAQ */}
            <FAQLink
              href={`${intl.formatMessage({
                id: "nav.faqLink"
              })}`}
            >
              <Text
                align="center"
                fontSize={[1]}
                fontFamily="Libre Baskerville"
                fontWeight="400"
                color="black"
                ml={[3]}
              >
                <FormattedMessage id="nav.faq" defaults="FAQ" />
              </Text>
            </FAQLink>
          </Box>
          <Box
            flexDirection={["row"]}
            w={[1, 1, 1, "654px"]}
            mt={[6]}
            mx="auto"
          >
            <Box flex={0}>
              <Steps
                direction="vertical"
                size={!isDesktopAndGreater ? "small" : "large"}
                current={currentStep}
              >
                <Step
                  onClick={() => this.goTo(1)}
                  title={
                    isDesktopAndGreater
                    //&& this.validateStep(1, currentStep, "contact")
                  }
                  description={<div>&nbsp;</div>}
                />
                <Step
                  onClick={
                    this.props.isCalculatorValid &&
                    this.props.calculatorEstimatedHomeValue > 250000
                      ? () => this.goTo(2)
                      : false
                  }
                  title={
                    isDesktopAndGreater
                    //&& this.validateStep(2, currentStep, "calculator")
                  }
                  description={<div>&nbsp;</div>}
                />
              </Steps>
            </Box>
            <Box flex={1}>
              <Wizard
                {...this.props}
                loanMaxAmount={this.state.loanMaxAmount}
              />
            </Box>
          </Box>
        </Box>
        <Footer {...this.props} />
      </Box>
    )
  }
}

const mapStateToProps = state => {
  const selector = formValueSelector("newMortgageWizard")
  const isValid = value => !isNil(value) && !isEmpty(value)
  const calculatorProvince = selector(state, "calculatorProvince")
  const calculatorTown = selector(state, "calculatorTown")
  const calculatorAgeOfYoungestHomeOwner = selector(
    state,
    "calculatorAgeOfYoungestHomeOwner"
  )
  const calculatorEstimatedHomeValue = selector(
    state,
    "calculatorEstimatedHomeValue"
  )
  const isCalculatorValid =
    isValid(calculatorProvince) &&
    isValid(calculatorTown) &&
    isValid(calculatorAgeOfYoungestHomeOwner) &&
    isValid(calculatorEstimatedHomeValue)
  const loanMaxAmount = state.loanMaxAmount

  return {
    isCalculatorValid: isCalculatorValid,
    calculatorProvince: calculatorProvince,
    calculatorTown: calculatorTown,
    calculatorAgeOfYoungestHomeOwner: calculatorAgeOfYoungestHomeOwner,
    calculatorEstimatedHomeValue: calculatorEstimatedHomeValue,
    loanMaxAmount: loanMaxAmount
  }
}
export default compose(connect(mapStateToProps, null), WithSizes, injectIntl)(
  Container
)



// WEBPACK FOOTER //
// ./src/containers/new-mortgage/new-mortgage.container.js